import React from 'react';

// `id` sin prefijo: PanelEdicion hace scroll a "seccion_<id>" desde sus botones de sección
const SeccionPanel = ({ id, numero, titulo, ubicacion, activa, onFocus, children }) => (
    <div id={'seccion_' + id} onFocusCapture={onFocus} className={'seccion_panel' + (activa ? ' seccion_panel_activa' : '')}>
        <p className='seccion_panel_titulo'>{numero ? numero + '. ' : ''}{titulo}</p>
        {ubicacion && <p className='seccion_panel_ubicacion'>{ubicacion}</p>}
        {children}
    </div>
);

export default SeccionPanel;
